<template>
  <div class="color-palette" v-show="visible" :style="position">
    <div class="color-block" v-if="shownone" style="border: 1px solid #ccc;  box-sizing: border-box; " @click.stop="$emit('colorPicked', 'transparent')" >
      <svg  viewBox="0 0 24 24">
          <path fill="#ccc" d="m 4.57,18.73 a 0.5,0.5 0 0 0 0,0.7 0.5,0.5 0 0 0 0.71,0 L 19.42,5.28 a 0.5,0.5 0 0 0 0,-0.71 0.5,0.5 0 0 0 -0.71,0 l 0,0 L 4.58,18.72 a 0.5,0.5 0 0 0 0,0 z" />
        </svg>
    </div>
    <div class="color-block" v-for="color in colors" :key="color" :style="{ backgroundColor: color }" @click.stop="$emit('colorPicked', color)" >
    </div>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      default: true,
      type: Boolean
    },
    colors: {
      type: Array,
      default: () => []
    },
    shownone: {
      type: Boolean,
      default: false,
    },
    showAbove: {
      type: Boolean
    }
  },
  computed: {
    position () {
      if (this.showAbove) { 
        return {
          bottom: '60px',
        }
      } else {
          return {
          top: '45px',
        }
      }
    }
  }
}
</script>

<style scoped>
  .color-palette {
    position: absolute;
    background: #fff;
    padding: 10px;
    display: flex;
    box-shadow: 0px 3px 20px 0 rgba(0, 0, 0, .12);
    flex-wrap: wrap;
    width: max-content;
    max-width: 168px;
  }

  .color-block {
    height:30px; 
    width:30px; 
    border-radius:3px; 
    margin:6px
  }
</style>